export default "__VITE_ASSET__d22d5e75__"